/**
 * @fileoverview GET handler for the "/apps/catalogs/:catalog_id/filtered_sets/:filtered_set_name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdFilteredSetsFilteredSetName } from "./constants";
import type { AppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult } from "./types";
import { isAppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult } from "./validators";

export const getAppsCatalogsCatalogIdFilteredSetsFilteredSetName = reactQueryFetcherAdapter(
  appsCatalogsCatalogIdFilteredSetsFilteredSetName,
  (
    signal: AbortSignal,
    catalogId: string,
    filteredSetName: string
  ): Promise<AppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult> => {
    return fetch(`/apps/catalogs/${catalogId}/filtered_sets/${filteredSetName}`, "GET", {}, { signal });
  },
  isAppsCatalogsCatalogIdFilteredSetsFilteredSetNameResult
);
